<template>
    <div
        class="px-4"
    >
        <div
            v-if="!mobile"
            class="text-center mb-3"
        >
            <img
                class="svg-icon-avatar"
                :src="svgPath"
                width="150"
                height="150"
            >
        </div>

        <v-layout
            wrap
            row
        >
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        :x-large="!isMobile"
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ parseInt(client.gender) !== 1 ? '$mdiLegacyFemale' : '$mdiLegacyMale' }}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ parseInt(client.gender) !== 1 ? 'Female' : 'Male' }}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        :x-large="!isMobile"
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ parseInt(client.smoker) !== 1 ? '$mdiLegacySmoking' : '$mdiLegacySmokingOff'}}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        {{ parseInt(client.smoker) !== 1 ? 'Smoker' : 'Non-smoker'}}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        :x-large="!isMobile"
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        $mdiLegacyANB
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        ANB: {{ parseInt(client.age) + 1 }}
                    </h4>
                </div>
            </v-flex>
            <v-flex
                xs6
                sm6
                md3
                class="summary-icons-flex"
            >
                <div
                    class="my-cover-carousel-border d-flex flex-column justify-center align-center fill-height"
                    :class="mobile ? 'pa-0' : 'mb-3 px-1 py-3'"
                >
                    <v-icon
                        :x-large="!isMobile"
                        class="mb-2"
                        :color="$vuetify.theme.dark ? '' : 'primary'"
                    >
                        {{ '$mdiLegacyCat' + client_rating }}
                    </v-icon>
                    <h4
                        :class="$vuetify.theme.dark ? 'white--text' : 'primary--text'"
                    >
                        Category
                    </h4>
                </div>
            </v-flex>
        </v-layout>
    </div>
</template>

<script>
    import MyCoverMixin from "../../mycover";

    export default {
        name: 'My-Cover-Summary-Icons',

        mixins: [
            MyCoverMixin
        ],

        props: {
            'mobile': {
                type: Boolean,
                default: false,
            }
        },

        computed: {
            svgPath() {
                let url = parseInt(this.client.gender) !== 1 ? 'female' : 'male';

                if (this.client.age <= 33) {
                    url += '-young';
                }

                if (this.client.age >= 48) {
                    url += '-old';
                }

                return '/static/calculators/' + url + '.svg';
            }
        },

        data() {
            return {}
        },

        methods: {}
    }
</script>
